import { ReactElement } from "react";
import { useNavigate } from "react-router";
import { FullPageSpinner, Icon } from "../../components";
import { useDashboardContext } from "../../components/dashboard/Dashboard.shared";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import { CUSTOMER_CONVERSATION, CUSTOMERS } from "../../constants/routes";
import { useSupplierRelationship } from "../../hooks/api/v2/supplierRelationship/useSupplierRelationship";
import { useParentNavigation } from "../../hooks/useParentNavigation";
import { BusinessConnection } from "./businessConnection/BusinessConnection";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { BusinessConnectionV2 } from "./businessConnection/BusinessConnectionV2";

export function Customer({
  connectionId,
}: {
  connectionId: number;
}): ReactElement {
  const { isTwoPanel } = useDashboardContext();
  const navigate = useNavigate();

  const connectionQuery = useSupplierRelationship(connectionId);

  const navigateToParent = useParentNavigation({
    fallback: CUSTOMERS,
  });

  const editCustomerV2Enabled =
    useRemoteFeatureFlags().isActive("editCustomerV2");

  return (
    <div className={"min-h-screen bg-white"}>
      <NavigationBar
        title={connectionQuery.data?.Retailer.Business.name ?? "Loading..."}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={navigateToParent}
        rightComponent={
          isTwoPanel ? undefined : (
            <div
              className={"cursor-pointer"}
              onClick={() =>
                navigate(CUSTOMER_CONVERSATION.href({ connectionId }))
              }
            >
              <Icon icon={"MESSAGE_REPLY_TEXT"} />
            </div>
          )
        }
      />
      {connectionQuery.isError ? (
        <ErrorMessage>{connectionQuery.error.message}</ErrorMessage>
      ) : connectionQuery.isLoading || !connectionQuery.data ? (
        <FullPageSpinner />
      ) : editCustomerV2Enabled ? (
        <BusinessConnectionV2 connection={connectionQuery.data} />
      ) : (
        <BusinessConnection connection={connectionQuery.data} />
      )}
    </div>
  );
}
